import gql from 'graphql-tag';
import moment from 'moment-timezone';

const createVideoQuery = gql`
  mutation createVideo(
    $organisationId: String!
    $input: NewVideoInput!
    $folderId: String
    $projectId: String
    $isElevateWorkflow: Boolean
  ) {
    createVideo(
      organisationId: $organisationId
      input: $input
      folderId: $folderId
      projectId: $projectId
      isElevateWorkflow: $isElevateWorkflow
    ) {
      videoId
    }
  }
`;

const createVideo = (organisationId?: string) => ({
  mutation: createVideoQuery,
  module: 'video',
  buildVariables: ({
    name,
    projectType,
    videoFolderId,
    videoProjectId,
    isPrivate,
    product,
    serviceType
  }: {
    name: string;
    projectType: string;
    videoFolderId?: string;
    videoProjectId?: string;
    isPrivate?: boolean;
    product?: string;
    serviceType: string;
  }) => ({
    organisationId,
    isElevateWorkflow: true,
    folderId: videoFolderId,
    projectId: videoProjectId,
    input: {
      name,
      projectType,
      isPrivate,
      submittedTimezone: moment.tz.guess(),
      product,
      serviceType,
      projectConfig: {
        isAIComposeEnabled: false,
        toolsConfig: [],
        syncToCue: false,
        defaultQuestionsKeys: [],
        isRequestAssistance: false
      }
    }
  })
});

export default createVideo;
